import React, { useState, useEffect } from 'react';
import { cleanInput } from "../../helpers/input";
import { dateToMomentObject, formatDate } from '../../helpers/date';

import style from './style.module.css';

const InputDisplay = ({ input, label = false, emptyValue = "-", formatAsDate = false, className = "", checkValue = false }) => {
    const [value, setValue] = useState(cleanInput(input?.value))

    useEffect(() => {
        if (input?.value) {
            if (formatAsDate === true) {
                setValue(formatDate(dateToMomentObject(input?.value)))
            }
            else {
                setValue(cleanInput(input?.value))
            }
        }
        if (checkValue !== false) {
            setValue(input.value === 1 ? "Yes" : "No")
        }
    }, [input?.value, formatAsDate, value, checkValue])

    return (
        <div className={`${style.inputDisplay}${className ? ' ' + className : ''}`}>
            <span className={style.displayLabel}>{label} :</span>
            <span className={style.displayText}>{value || emptyValue}</span>
        </div>
    )
}

export default InputDisplay
